<template>
  <div>
    <a-button type="primary" :disabled="disabled" @click="showModal">
      {{ $t('生成凭证') }}
    </a-button>

    <a-modal :title="$t('生成凭证')" v-model="visible" @cancel="visible = false">
      <a-form-model>
        <a-form-model-item :label="$t('生成方式')" required v-if="selectedRows.length > 1">
          <a-radio-group v-model="generateType" style="width: 100%">
            <a-radio value="one">{{ $t('单个生成') }}</a-radio>
            <a-radio value="all">{{ $t('汇总生成') }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :label="$t('凭证模板')" required>
          <a-select v-model="templateId" style="width: 100%" :loading="queryLoading">
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">
              {{ item.template_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="visible = false">{{ $t('取消') }}</a-button>
        <a-button type="primary" :loading="loading" @click="clickHandle">
          {{ $t('确定') }}
        </a-button>
      </template>
    </a-modal>

    <ResultModal
      ref="resultModalRef"
      :title="$t('生成凭证结果')"
      :errorMessageList="errorMessageList"
      :successMessageList="voucherList"
      :successColumns="voucherColumns"
      @cancel="cancelHandle"
      @jump="goToVoucherDetail"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import ResultModal from '@/component/resultModal'
export default {
  components: { ResultModal },
  props: {
    docType: {
      type: String,
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      queryLoading: false,
      visible: false,
      templateList: [],
      generateType: 'one',
      templateId: undefined,
      errorMessageList: [],
      voucherList: [],
    }
  },
  computed: {
    voucherColumns() {
      return [
        {
          title: this.$t('单据号'),
          dataIndex: 'doc_sn_list',
          width: 300,
          customRender: (text) => {
            return text.join(',')
          },
        },
        {
          title: this.$t('凭证单据号'),
          dataIndex: 'voucher_sn',
          scopedSlots: {
            customRender: 'voucher_sn',
          },
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    async getVoucherTemplateList() {
      if (this.templateList.length > 0) return
      this.queryLoading = true
      await http({
        url: api.getVoucherTemplateList,
        data: {
          doc: this.docType,
        },
        success: (res) => {
          let list = res.result.list
          this.templateList = list
          if (list.length === 1) {
            this.templateId = list[0].id
          }
        },
      })
      this.queryLoading = false
    },
    showModal() {
      this.visible = true
      this.getVoucherTemplateList()
    },
    async clickHandle() {
      this.loading = true
      try {
        if (this.generateType === 'one') {
          let results = await Promise.allSettled(
            this.selectedRows.map((row) => this.generateVoucherHandle([row.id]))
          )
          console.log('results', results) // 处理每个结果
          let errorMessageList = [],
            voucherList = []
          results.forEach((item, index) => {
            if (item.status === 'rejected') {
              // this.$message.error(item.reason)
              let orderItem = this.selectedRows[index]
              errorMessageList.push({
                doc_sn:
                  orderItem.paymentNoteSn ||
                  orderItem.orderSn ||
                  orderItem.depreciationNo ||
                  orderItem.orderCode,
                msg: item.reason,
              })
              return
            }
            let { error_message_list, voucher_list } = item.value.result
            if (error_message_list?.length > 0) {
              errorMessageList.push(...error_message_list)
            }
            if (voucher_list?.length > 0) {
              voucherList.push(...voucher_list)
            }
          })
          this.handleVoucherResult({
            error_message_list: errorMessageList,
            voucher_list: voucherList,
          })
        } else if (this.generateType === 'all') {
          const docIds = this.selectedRows.map((row) => row.id)
          let { result } = await this.generateVoucherHandle(docIds)
          console.log('result', result)
          this.handleVoucherResult(result)
        }
        // this.$message.success(this.$t('凭证生成成功'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error || this.$t('凭证生成失败'))
      } finally {
        this.loading = false
      }
    },
    async generateVoucherHandle(docIds) {
      try {
        let res = await http({
          url: api.generateVoucher,
          data: {
            docIds,
            docType: this.docType,
            templateId: this.templateId,
          },
          fail: () => {},
        })
        return Promise.resolve(res)
      } catch (err) {
        return Promise.reject(err.msg)
      }
    },
    handleVoucherResult(result) {
      let { error_message_list, voucher_list } = result
      if (error_message_list.length > 0 || voucher_list.length > 0) {
        this.$refs.resultModalRef.show()
        this.errorMessageList = error_message_list
        this.voucherList = voucher_list
      }
    },
    goToVoucherDetail(record) {
      this.addPane({
        view: 'voucherDetail/' + record.voucher_sn,
        name: 'detailSn',
        query: {
          id: record.voucher_id,
          sn: record.voucher_sn,
        },
        route: `/voucherManage/voucherDetail?id=${record.voucher_id}&sn=${record.voucher_sn}`,
      })
    },
    cancelHandle() {
      this.$emit('close')
    },
  },
}
</script>
